
      // Signal that dependencies are loading
      window.dependenciesLoading = true;
      
      try {
        const { IbiraAPIFetchManager } = await Promise.race([
          import('https://cdn.jsdelivr.net/gh/mpbarbosa/ibira.js@0.2.2-alpha/src/index.js'),
          new Promise((_, reject) => setTimeout(() => reject(new Error('CDN timeout after 5s')), 5000))
        ]);
        window.IbiraAPIFetchManager = IbiraAPIFetchManager;
        console.log('✓ IbiraAPIFetchManager loaded successfully from CDN');
      } catch (error) {
        console.warn('⚠️ Failed to load IbiraAPIFetchManager from CDN:', error.message);
        console.log('✓ Application will use fallback fetch implementation');
        // App will use fallback - guia.js has IbiraAPIFetchManagerFallback
      } finally {
        // Signal that dependencies are ready
        window.dependenciesLoading = false;
        window.dispatchEvent(new Event('dependencies-ready'));
      }
    